<template>
  <!-- <div v-if="requestData?.status !== 'cancel'" class="flex justify-evenly gap-10 rounded-xl bg-[var(--c-primary)] p-8 mb-6">
    <ButtonWhite @click="handleClickCancelRequest" class="flex items-center gap-2" :icon="CancelIcon"
      :title="$t('requestDetail.actions.cancelRequest')" />
  </div> -->

  <!-- Espaciador visual -->
  <!-- <div style="height: 32px;"></div> -->

  <div v-if="loading">
    <titlePrimary class="client-detail-title w-full" :title="$t('requestDetail.titles.request')" />
  </div>
  <div v-else-if="error" class="text-red-500 text-center p-4">
    {{ error }}
  </div>
  <div v-else class="request-detail-header">
    <titlePrimary class="client-detail-title w-full text-lg" :title="$t('requestDetail.titles.request') + ' ' + requestData.code" />
    <div v-if="canChangeType" class="request-type-action px-2 sm:px-4">
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-md border border-[#c1c1c1] bg-white px-4 py-2 text-base leading-6 text-[#385660] shadow-sm cursor-pointer transition-colors hover:bg-[#eafaff] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#25B0D7]"
        @click="showTypeModal = true"
      >
        {{ $t('requestTypeChange.action') }}
        <ChangeIcon class="h-5 w-5 shrink-0" />
      </button>
    </div>
  </div>

  <div class="py-4 sm:py-6 px-2 sm:px-4 bg flex flex-col gap-4 text-[#7CADB9] ">
    <!-- La solicitud pertenece a otro gestor: se puede consultar, no modificar. -->
    <div v-if="isAssignedToAnotherManager"
      class="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      {{ $t('requestDetail.locked.assignedToAnotherManager') }}
    </div>

    <!-- DATOS DE LA SOLICITUD -->
    <div class="client-detail-card flex flex-col justify-between gap-x-2 p-3 sm:p-4 md:flex-row">
      <div class="flex flex-col justify-end gap-1 py-2 flex-1">
        <span class="font-semibold text-black">Estado de la solicitud</span>
        <span class="text-[#7CADB9] text-lg font-semibold border border-gray-300 rounded-md p-2">{{ $t(`common.requestStatus.${requestData?.status}`) || requestData?.status || '-' }}</span>
      </div>
      <div class="flex flex-col justify-end gap-1 py-2 flex-1">
        <span class="font-semibold text-black">Administrador</span>
        <span class="text-[#7CADB9] text-lg font-semibold border border-gray-300 rounded-md p-2">{{ clientAccountName }}</span>
      </div>
      <!-- Tipo de cuenta del cliente: dato interno para el gestor de ADS -->
      <div v-if="isAdsUser" class="flex flex-col justify-end gap-1 py-2 flex-1">
        <span class="font-semibold text-black">{{ $t('requestDetail.labels.accountType') }}</span>
        <span class="text-[#7CADB9] text-lg font-semibold border border-gray-300 rounded-md p-2">{{ clientAccountTypeLabel }}</span>
      </div>
      <div class="flex flex-col justify-end gap-1 py-2 flex-1">
        <span class="font-semibold text-black">{{ $t('requestDetail.labels.typology') }}</span>
        <span class="text-[#7CADB9] text-lg font-semibold border border-gray-300 rounded-md p-2">{{ typeLabel }}</span>
      </div>
      <div class="flex flex-col justify-end gap-1 py-2 flex-1">
        <span class="font-semibold text-black">Persona asignada</span>
        <span class="text-[#7CADB9] text-lg font-semibold border border-gray-300 rounded-md p-2">{{ requestData?.assigned_to?.name ?? '-' }}</span>
      </div>
    </div>

    <!-- Primera fila: dos cajas en la misma fila -->
    <div class="flex flex-col lg:flex-row gap-4">
      <!-- Columna de datos: cliente y suministro -->
      <div class="flex flex-col w-full lg:w-1/2 gap-0 flex-1 min-w-0">
        <!-- DATOS DEL TITULAR: el cliente lo ve en toda tipología, en solo lectura.
             Lo informa al crear la solicitud y después lo mantiene ADS (ADS-0171). -->
        <template v-if="requestData?.can_view_holder_data === true">
          <div class="pb-2">
            <titlePrimary class="client-detail-title mb-1" :title="$t('requestDetail.titles.clientData')" />
          </div>
          <div class="client-detail-card overflow-y-auto p-3 sm:p-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
              <div v-if="loading" class="col-span-full text-center p-4">
                {{ $t('requestDetail.loading.propertyData') }}
              </div>
              <div v-else-if="error" class="col-span-full text-red-500 text-center p-4">
                {{ error }}
              </div>
              <template v-else-if="requestData">
                <!-- Nombre, apellidos, DNI y teléfono los mantiene ADS desde aquí,
                     en cualquier tipología. -->
                <HolderDataForm
                  :request-data="requestData"
                  :disabled="requestData?.can_edit_holder_data !== true || isRequestLockedForWriting"
                  @saved="handleHolderDataSaved"
                />
                <div v-if="requestData.contact_person" class="flex flex-col gap-1 py-2">
                  <span class="font-semibold text-black">{{ $t('requestDetail.labels.contactPerson') }}</span>
                  <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.contact_person }}</span>
                </div>
                <div v-if="visible.email" class="flex flex-col gap-1 py-2">
                  <span class="font-semibold text-black">{{ $t('requestDetail.labels.clientEmail') }}</span>
                  <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.email ?? '-' }}</span>
                </div>
                <div v-if="visible.iban" class="flex flex-col gap-1 py-2 md:col-span-2">
                  <span class="font-semibold text-black truncate">{{ $t('requestDetail.labels.iban') }}</span>
                  <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2 ">{{ requestData.iban ?? '-' }}</span>
                </div>
                <div v-if="visible.user_address" class="flex flex-col gap-1 py-2 md:col-span-2">
                  <span class="font-semibold text-black truncate">{{ $t('requestDetail.labels.correspondenceAddress') }}</span>
                  <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2 ">{{ requestData.user_address ?? '-' }}</span>
                </div>
                <div v-if="visible.user_address" class="flex flex-col gap-1 py-2 md:col-span-2">
                  <span class="font-semibold text-black truncate">{{ $t('requestDetail.labels.correspondencePopulation') }}</span>
                  <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2 ">{{ requestData.correspondence_population ?? '-' }}</span>
                </div>

              </template>
            </div>
          </div>
        </template>
        <!-- DATOS DEL SUMINISTRO -->
        <div class="pb-2" :class="{ 'pt-4': requestData?.can_view_holder_data === true }">
          <titlePrimary class="client-detail-title mb-1" :title="$t('requestDetail.titles.supplyData')" />
        </div>
        <div class="client-detail-card overflow-y-auto p-3 sm:p-4 lg:grow">
        <!-- <div class="p-3 sm:p-4 rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] overflow-y-auto"> -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
            <!-- DATOS DEL SUMINISTRO -->
            <div v-if="loading" class="text-center p-4">
              {{ $t('requestDetail.loading.propertyData') }}
            </div>
            <div v-else-if="error" class="text-red-500 text-center p-4">
              {{ error }}
            </div>
            <!-- <div v-else-if="requestData">
              <InputPrimary type="text" :label="$t('requestDetail.labels.cupsLight')"
                :placeholder="$t('requestDetail.placeholders.cupsLight')" :modelValue="requestData.cups_light ?? '-'"
                placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000"  />
              <InputPrimary type="text" :label="$t('requestDetail.labels.cupsGas')"
                :placeholder="$t('requestDetail.placeholders.cupsGas')" :modelValue="requestData.cups_gas ?? '-'"
                placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000"  />
              <InputPrimary class="md:col-span-2" type="text" :label="$t('requestDetail.labels.supplyPointAddress')"
                :placeholder="$t('requestDetail.placeholders.supplyPointAddress')"
                :modelValue="requestData.supply_address ?? '-'" placeholderColor="#7CADB9" textColor="#7CADB9"
                labelColor="#000000"  />
              <InputPrimary type="text" :label="$t('requestDetail.labels.postalCode')"
                :placeholder="$t('requestDetail.placeholders.postalCode')" :modelValue="requestData.postal_code ?? '-'"
                placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000"  />
              <InputPrimary type="text" :label="$t('requestDetail.labels.municipality')"
                :placeholder="$t('requestDetail.placeholders.municipality')" :modelValue="requestData.municipality ?? '-'"
                placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000"  />
            </div> -->
            <template v-else-if="requestData">
              <div v-if="visible.cups" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.cupsLight') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ cupsLightValue || '-' }}</span>
              </div>
              <div v-if="visible.cups" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.cupsGas') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ cupsGasValue || '-' }}</span>
              </div>
              <div v-if="visible.meter_readings || requestData.light_meter_reading" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.lightMeterReading') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.light_meter_reading || '-' }}</span>
              </div>
              <div v-if="visible.meter_readings || requestData.gas_meter_reading" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.gasMeterReading') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.gas_meter_reading || '-' }}</span>
              </div>
              
              <div v-if="visible.supply_address" class="flex flex-col gap-1 py-2 md:col-span-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.supplyPointAddress') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestSupplyAddress }}</span>
              </div>
              <div v-if="visible.postal" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.postalCode') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.postal_code ?? '-' }}</span>
              </div>
              <div v-if="visible.municipality" class="flex flex-col gap-1 py-2">
                <span class="font-semibold text-black">{{ $t('requestDetail.labels.municipality') }}</span>
                <span class="text-[#7CADB9] text-lg border border-gray-300 rounded-md p-2">{{ requestData.municipality ?? '-' }}</span>
              </div>

              <div v-if="requestData.includes_water" class="flex items-center gap-2 py-2 md:col-span-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[#2AB4D9] shrink-0" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 11.586 7.707 10.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <span class="font-semibold text-[#385660]">{{ $t('form.labels.includes_water') }}</span>
              </div>

              <!-- Solicitudes relacionadas por CUPS Luz -->
              <div class="flex flex-col gap-1 py-2 md:col-span-2">
                <span class="font-semibold text-black">{{ $t('requestDetailAdmin.labels.relatedRequests') || 'Solicitudes con el mismo CUPS Luz' }}</span>
                  <select class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-[#7CADB9]" :disabled="!relatedRequests.length" @change="e => navigateToRequest(e.target.value)">
                    <option value="" disabled selected>Selecciona una solicitud</option>
                    <option v-for="req in relatedRequests" :key="req.id" :value="req.id">
                      {{ req.code }} - {{ $t(`common.requestStatus.${req.status}`) }}
                    </option>
                  </select>
                <div v-if="!relatedRequests.length && cupsLightValue" class="text-xs text-gray-400 italic py-2 mt-2">
                  No hay otras solicitudes con este CUPS Luz.
                </div>
                <div v-else-if="!cupsLightValue" class="text-xs text-gray-400 italic py-2 mt-2">
                  Sin CUPS Luz para buscar solicitudes relacionadas.
                </div>
              </div>
              <!-- Solicitudes relacionadas por CUPS Gas -->
              <div class="flex flex-col gap-1 py-2 md:col-span-2">
                <span class="font-semibold text-black">{{ $t('requestDetailAdmin.labels.relatedGasRequests') || 'Solicitudes con el mismo CUPS Gas' }}</span>
                  <select class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm text-[#7CADB9]" :disabled="!relatedGasRequests.length" @change="e => navigateToRequest(e.target.value)">
                    <option value="" disabled selected>Selecciona una solicitud</option>
                    <option v-for="req in relatedGasRequests" :key="req.id" :value="req.id">
                      {{ req.code }} - {{ $t(`common.requestStatus.${req.status}`) }}
                    </option>
                  </select>
                <div v-if="!relatedGasRequests.length && cupsGasValue" class="text-xs text-gray-400 italic py-2 mt-2">
                  No hay otras solicitudes con este CUPS Gas.
                </div>
                <div v-else-if="!cupsGasValue" class="text-xs text-gray-400 italic py-2 mt-2">
                  Sin CUPS Gas para buscar solicitudes relacionadas.
                </div>
              </div>
            </template>
             
          </div>
        </div>
        <ContractImprovementBlock
          v-if="!isAdsUser && requestData && (supportsContractImprovement(requestData.type) || requestData.contract_improvement_accepted_at)"
          class="client-detail-card contract-improvement-under-supply"
          :requestData="requestData"
          :disabled="isRequestLockedForWriting"
          @saved="fetchRequestDetail"
        />
      </div>
      <!-- Columna de chat independiente -->
      <div class="flex flex-col w-full lg:w-1/2 gap-0 min-w-0">
        <!-- NOTIFICACIONES Chat -->
        <div class="pb-2">
          <titlePrimary class="client-detail-title mb-1" :title="$t('requestDetail.titles.notifications')" />
        </div>
        <div v-if="loading" class="text-center p-4">
          {{ $t('requestDetail.loading.propertyData') }}
        </div>
        <div v-else-if="error" class="text-red-500 text-center p-4">
          {{ error }}
        </div>
        <div v-else-if="requestData" class="flex flex-1 min-h-[270px] sm:min-h-[330px] lg:min-h-[400px]">
          <Notes :message="requestData.notifications" :request_id="requestData.id.toString()"
            :sentToId="requestData.manager?.id ?? null" :isReadOnly="isRequestLockedForWriting"
            class="client-detail-card client-detail-chat-card" />
        </div>
      </div>
    </div>

    <template v-if="requestData?.can_view_operational_details">
      <titlePrimary :title="$t('requestDetailAdmin.internalOperation.title')" class="client-detail-title w-full" />
      <div class="client-detail-card p-3 sm:p-4">
        <OperationalTracking
          :request-data="requestData"
          :disabled="isRequestLockedForWriting"
          @saved="handleOperationalDetailsSaved"
        />
      </div>
    </template>

    <!-- Observaciones, Modificaciones, Observaciones Cuenta -->
    <!-- <div class="flex flex-col gap-4">
      <div class="w-full py-4 sm:py-6 px-3 sm:px-4 rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
        <label for="comments" class="text-sm sm:text-base font-medium text-black">{{ $t('requestDetailAdmin.labels.observations') }}:</label>
        <textarea :value="requestData?.observations || ''"
          @input="e => requestData && (requestData.observations = e.target.value)"
          class="w-full p-2 h-[120px] sm:h-[160px] text-sm sm:text-base text-[#7CADB9] resize-none rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] mt-2"></textarea>
      </div>
    </div> -->

    <!-- Columnas adicionales (una al lado de otra en desktop) -->
    <div class="flex flex-col lg:flex-row gap-4">
      <!-- Nueva caja: DATOS DE LA SOLICITUD -->
      <!-- <div class="w-full lg:w-1/2 flex flex-col gap-2 sm:gap-4">
        <titlePrimary title="DATOS DE LA SOLICITUD" /> -->
        <!-- <div class="p-4 sm:p-6 lg:p-8 rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] grid grid-cols-1 gap-y-2"> -->
        <!-- <div class="p-4 sm:p-6 lg:p-8 rounded-xl grid grid-cols-1 gap-y-2">
          <InputPrimary type="text" label="Estado de la solicitud" :modelValue="$t(`common.requestStatus.${requestData?.status}`) || requestData?.status || '-'"
            placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000" />
          <InputPrimary type="text" label="Administrador" :modelValue="requestData?.manager?.name ?? '-'"
            placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000" />
          <InputPrimary type="text" :label="$t('requestDetail.labels.typology')" :modelValue="typeLabel"
            placeholderColor="#7CADB9" textColor="#7CADB9" labelColor="#000000" />
          <InputPrimary type="text" label="Persona asignada"
            :modelValue="requestData?.assigned_person ?? requestData?.manager?.name ?? '-'" placeholderColor="#7CADB9"
            textColor="#7CADB9" labelColor="#000000" />
        </div>
      </div> -->
    </div>

    <!-- Línea temporal, histórico y archivos -->
    <div class="w-full flex flex-col gap-2 sm:gap-4">
      <!-- HISTÓRICO INTERNO DE TRAZABILIDAD (solo perfiles autorizados) -->
      <template v-if="canViewHistory">
        <titlePrimary :title="$t('requestHistory.title')" class="client-detail-title w-full mt-4" />
        <p class="text-sm text-[#7CADB9] -mt-1">{{ $t('requestHistory.subtitle') }}</p>
        <RequestHistory :requestId="id" />
      </template>

      <!-- Cabecera colapsable: el histórico de estados arranca oculto y se despliega al pulsar -->
      <button
        type="button"
        class="w-full text-left"
        :aria-expanded="showTimeline"
        @click="showTimeline = !showTimeline"
      >
        <titlePrimary :title="$t('requestDetail.titles.timeline')" class="client-detail-title w-full cursor-pointer">
          <svg
            class="w-4 h-4 text-white transition-transform duration-300"
            :class="{ 'rotate-180': showTimeline }"
            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </titlePrimary>
      </button>

      <div class="client-detail-card">
        <div v-if="requestData" class="grid grid-cols-1 gap-4 p-4 sm:grid-cols-3 sm:gap-6 sm:p-6 lg:p-8">
          <div class="flex flex-col gap-1">
            <span class="text-xs font-medium uppercase tracking-wider text-[#42A9C2]">{{ $t('requestDetail.timelineSummary.start') }}</span>
            <span class="text-sm text-gray-500">{{ statusTimeline.startLabel }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="text-xs font-medium uppercase tracking-wider text-[#42A9C2]">{{ $t('requestDetail.timelineSummary.end') }}</span>
            <span class="text-sm text-gray-500">{{ statusTimeline.endLabel }}</span>
          </div>
          <div class="flex flex-col gap-1">
            <span class="text-xs font-medium uppercase tracking-wider text-[#42A9C2]">{{ $t('requestDetail.timelineSummary.total') }}</span>
            <span class="text-sm text-gray-500">{{ statusTimeline.totalDurationLabel }}</span>
          </div>
        </div>
        <div v-if="showTimeline" class="flex flex-col gap-4 border-t border-gray-200 p-4 sm:p-6 lg:p-8">
          <div v-if="loading" class="text-center p-4">
            {{ $t('requestDetail.loading.propertyData') }}
          </div>
          <div v-else-if="error" class="text-red-500 text-center p-4">
            {{ error }}
          </div>
          <div v-else-if="requestData" class="flex flex-col gap-4">
            <!-- informacion -->
            <!-- linea de eventos -->
            <div v-if="statusTimeline.events.length" class="relative w-full pt-4 pb-2">
              <!-- raya horizontal -->
              <div class="absolute left-0 right-0 top-1/2 h-1 bg-blue-100 rounded-full"></div>
              <div class="relative h-12">
                <!-- rayas marca tiempos -->
                <div v-for="tick in statusTimeline.scaleTicks" :key="tick.id"
                  :style="{ left: tick.position + '%' }"
                  class="absolute top-4 h-12 flex flex-col items-center -translate-x-1/2">
                  <div class="w-0.5 h-3 bg-gray-300"></div>
                  <div class="text-xs text-gray-400 mt-1">{{ tick.label }}</div>
                </div>
                <!-- marca puntos de estado -->
                <div v-for="event in statusTimeline.events" :key="event.id"
                  :style="{ left: event.position + '%' }"
                  class="absolute top-0 h-12 flex flex-col items-center -translate-x-1/2">
                  <div class="text-xs text-[#385660] text-center">{{ event.titleLabel }}</div>
                  <div :class="['w-3 h-3 rounded-full', event.isLast ? 'bg-[#2AB4D9]' : 'bg-[#385660]']"></div>
                </div>
              </div>
            </div>

            <!-- detalles de los eventos -->
            <div v-if="statusTimeline.events.length" class="flex flex-col gap-2 max-h-[280px] overflow-y-auto pr-1">
              <div v-for="entry in statusTimeline.events" :key="entry.id"
                class="border border-gray-300 rounded-md p-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                <div class="flex flex-col">
                  <div class="text-sm font-semibold text-[#385660]">{{ entry.titleLabel }}</div>
                  <div class="text-xs text-gray-500">{{ entry.dateLabel }}</div>
                </div>
                <div class="text-xs text-gray-500">{{ entry.elapsedLabel }}</div>
              </div>
            </div>

            <div v-else class="text-sm text-gray-400 italic">
              No hay estados disponibles para construir la línea temporal.
            </div>
          </div>
        </div>
      </div>
      
      <titlePrimary :title="$t('requestDetail.titles.files')" class="client-detail-title w-full">
        <RequestFilesZipButton :requestId="id" :requestCode="requestData?.code || ''" :items="itemsFiles"
          :selection="fileSelection" />
        <ButtonWhite
          v-if="canUploadFiles && !isRequestLockedForWriting"
          class="!w-auto !px-3 !py-1 !rounded-md !shadow-sm shrink-0 self-center text-sm leading-5"
          :title="$t('requestFiles.upload')"
          @click="openDocumentUploadModal"
        />
      </titlePrimary>
      <div class="client-detail-card client-detail-files-card overflow-x-auto p-4 sm:p-6 lg:p-8">
        <TableComponent :fields="files" :fileDownload="true" :items="itemsFiles" :showOptions="true"
          :selection="fileSelection" />
        <div v-if="totalPagesFiles > 1" class="mt-4">
          <PaginateComponent :totalPages="totalPagesFiles" :modelValue="currentPageFiles"
            @update:modelValue="handlePageChangefiles" />
        </div>
      </div>

      <FileUploadDocumentModal
        :isOpen="showDocumentUploadModal"
        :requestId="id"
        @close="showDocumentUploadModal = false"
        @upload-success="handleDocumentUploadSuccess"
      />

      <!-- Confirmation Modal -->
      <div v-if="showConfirmModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4">
          <!-- Header -->
          <div class="flex items-center justify-between p-6 border-b">
            <h3 class="text-lg font-semibold text-[#385660]">{{ $t('requestDetail.confirmModal.title') || '¿Cancelar solicitud?' }}</h3>
            <button @click="handleCloseConfirmModal" class="text-gray-400 hover:text-gray-600 transition-colors">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
  
          <!-- Body -->
          <div class="p-6">
            <p class="text-gray-600">{{ $t('requestDetail.confirmModal.message') || '¿Estás seguro de que deseas cancelar esta solicitud? Esta acción no se puede deshacer.' }}</p>
          </div>
  
          <!-- Footer -->
          <div class="p-6 border-t flex gap-2 justify-end space-x-3">
            <button @click="handleCloseConfirmModal"
              class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
              {{ $t('requestDetail.confirmModal.cancel') || 'No, volver' }}
            </button>
            <button @click="confirmCancelRequest"
              class="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors cursor-pointer ">
              {{ $t('requestDetail.confirmModal.confirm') || 'Sí, cancelar solicitud' }}
            </button>
          </div>
        </div>
      </div>

      <RequestTypeModal
        :isOpen="showTypeModal"
        :currentType="requestData?.type"
        :currentOtherAction="requestData?.other_action"
        :request="requestData"
        :saving="isUpdatingType"
        :errorKeys="typeErrorKeys"
        @close="closeTypeModal"
        @confirm="handleTypeUpdate"
      />
  </div>
  </div>
</template>

<style scoped>
.client-detail-card {
  border: 1px solid #B9D3DA;
  border-radius: 0.75rem;
  background-color: #fff;
  box-shadow: none;
}

.client-detail-title {
  box-shadow: none;
}

.client-detail-chat-card :deep(.message-bubble) {
  border-color: #B9D3DA;
  border-radius: 0.75rem;
  box-shadow: none;
}

.contract-improvement-under-supply :deep(.rounded-xl.border) {
  border-color: #B9D3DA;
  box-shadow: none;
}

.client-detail-files-card :deep(tbody tr) {
  box-shadow: none;
}

.client-detail-files-card :deep(tbody td) {
  border-top: 1px solid #B9D3DA;
  border-bottom: 1px solid #B9D3DA;
}

.client-detail-files-card :deep(tbody td:first-child) {
  border-left: 1px solid #B9D3DA;
}

.client-detail-files-card :deep(tbody td:last-child) {
  border-right: 1px solid #B9D3DA;
}

.request-detail-header {
  margin-top: 1rem;
}

.request-type-action {
  margin-top: 1rem;
}

.contract-improvement-under-supply {
  margin-top: 1rem;
}
</style>


<script setup>
// import InputPrimary from "@/components/inputs/input-primary.vue";
import titlePrimary from "@/components/title/title-primary.vue";
import Notes from "@/components/common/NotesComponent.vue";
import ButtonWhite from "@/components/button/ButtonWhite.vue";
import RequestFilesZipButton from "@/components/request/RequestFilesZipButton.vue";
import { useRowSelection } from "@/composables/useRowSelection";
import { reactive } from "vue";
import ChangeIcon from "@/assets/svg/ChangeIcon.vue";
import FileUploadDocumentModal from "@/components/modal/FileUploadDocumentModal.vue";
import RequestTypeModal from "@/components/request/RequestTypeModal.vue";
import { requestTypeErrorKeys } from "@/services/requestTypeChange";
import RequestHistory from "@/components/request/RequestHistory.vue";
import OperationalTracking from "@/components/request/OperationalTracking.vue";
import HolderDataForm from "@/components/request/HolderDataForm.vue";
import { isAdsUser as checkIsAdsUser } from "@/services/userRoles";
import ContractImprovementBlock from "@/components/request/ContractImprovementBlock.vue";
import { supportsContractImprovement } from '@/services/contractImprovement';
import { accountTypeLabel } from "@/services/clientAccount";
import { deduplicateTimelineEvents } from "@/services/requestConversation";

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import { toast } from 'vue3-toastify';
import { useI18n } from 'vue-i18n';

const router = useRouter();

// Solicitudes relacionadas por CUPS Luz y Gas
const relatedRequests = ref([]); // solicitudes con el mismo CUPS Luz
const relatedGasRequests = ref([]); // solicitudes con el mismo CUPS Gas
const loadingRelated = ref(false);
const loadingRelatedGas = ref(false);

const normalizeCups = (value) => {
  const cups = String(value ?? '').trim();
  return ['', '.', '-', 'nd', 'n/d', 'na', 'n/a', 'no disponible'].includes(cups.toLowerCase()) ? '' : cups;
};

const cupsLightValue = computed(() => normalizeCups(requestData.value?.cups_light));
const cupsGasValue = computed(() => normalizeCups(requestData.value?.cups_gas));

const fetchRelatedRequests = async (cupsLightValue) => {
  cupsLightValue = normalizeCups(cupsLightValue);
  if (!cupsLightValue) {
    relatedRequests.value = [];
    return;
  }
  loadingRelated.value = true;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/request/user/search`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          query: cupsLightValue,
          per_page: 20,
          search_by: 'cups_light',
          cups_light: cupsLightValue
        },
      }
    );
    relatedRequests.value = response.data?.value?.data?.filter(
      req => req.id !== requestData.value?.id
    ) || [];
  } catch (error) {
    relatedRequests.value = [];
    console.error("Error buscando solicitudes relacionadas:", error);
  } finally {
    loadingRelated.value = false;
  }
};

const fetchRelatedGasRequests = async (cupsGasValue) => {
  cupsGasValue = normalizeCups(cupsGasValue);
  if (!cupsGasValue) {
    relatedGasRequests.value = [];
    return;
  }
  loadingRelatedGas.value = true;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/request/user/search`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          query: cupsGasValue,
          per_page: 20,
          search_by: 'cups_gas',
          cups_gas: cupsGasValue
        },
      }
    );
    relatedGasRequests.value = response.data?.value?.data?.filter(
      req => req.id !== requestData.value?.id
    ) || [];
  } catch (error) {
    relatedGasRequests.value = [];
    console.error("Error buscando solicitudes relacionadas por gas:", error);
  } finally {
    loadingRelatedGas.value = false;
  }
};

// ...existing code...
import TableComponent from "@/components/table/TableComponent.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
// import ButtonComponent from "@/components/button/button-component.vue";
// import ArrowLeft from "@/assets/svg/ArrowLeft.vue";
// import ArrowRight from "@/assets/svg/ArrowRight.vue";
// import CancelIcon from "@/assets/svg/CancelIcon.vue";
// import ButtonWhite from "@/components/button/ButtonWhite.vue";




const route = useRoute();
const { t: $t } = useI18n();
const id = route.params.id;

const requestData = ref(null);

const loading = ref(true);
const error = ref(null);
const pollingInterval = ref(null);
const isFirstLoad = ref(true);

// const currentYear = ref(new Date().getFullYear());
// const selectedMonth = ref(new Date().getMonth());
// const selectedDay = ref(null);

const itemsFiles = ref([]);
// Casillas para descargar en un ZIP solo los archivos marcados (ADSREC-0025).
const fileSelection = reactive(useRowSelection(computed(() => itemsFiles.value.length)));
const currentPageFiles = ref(1);
const totalPagesFiles = ref(1);
const showDocumentUploadModal = ref(false);
const showTypeModal = ref(false);
const isUpdatingType = ref(false);
// Motivo por el que el back rechazó el cambio de tipología, para mostrarlo en el modal.
const typeErrorKeys = ref([]);

const showConfirmModal = ref(false);
const showTimeline = ref(false); // línea temporal oculta por defecto
const isUpdatingStatus = ref(false);
const lastUpdateTime = ref(null);

// const months = ref([
//   "Enero",
//   "Febrero",
//   "Marzo",
//   "Abril",
//   "Mayo",
//   "Junio",
//   "Julio",
//   "Agosto",
//   "Septiembre",
//   "Octubre",
//   "Noviembre",
//   "Diciembre",
// ]);

const files = computed(() => [
  { key: "date", label: $t('requestFiles.columns.date') },
  { key: "documental_type", label: $t('requestFiles.columns.documentalType') },
  { key: "name", label: $t('requestFiles.columns.originalName') },
  { key: "user", label: $t('requestFiles.columns.uploader') },
  { key: "opciones", label: $t('requestFiles.columns.options') }
]);

// Computed properties
// const daysInMonth = computed(() => {
//   if (selectedMonth.value === null) return 0;
//   return new Date(currentYear.value, selectedMonth.value + 1, 0).getDate();
// });

const clientAccountName = computed(() => (
  requestData.value?.client_account?.name
  || requestData.value?.manager?.name
  || '-'
));

// Tipo de cuenta del cliente (horizontal, vertical o ambos), resuelto por el
// back en `client_account.type_label` con los nombres de la base de datos.
const clientAccountTypeLabel = computed(() => accountTypeLabel(requestData.value?.client_account, '-'));

const requestSupplyAddress = computed(() => (
  requestData.value?.supply_address
  || requestData.value?.supplies?.find((supply) => supply?.address)?.address
  || requestData.value?.property?.address
  || requestData.value?.property?.name
  || requestData.value?.user_address
  || '-'
));

const typeLabel = computed(() => {
  const type = requestData.value?.type;
  if (!type) return '-';

  const baseLabel = $t(`common.requestTypes.${type}`) || type;

  if (type === 'other_type') {
    const actionKey = requestData.value?.other_action;
    if (!actionKey) return baseLabel || '-';

    const candidateKeys = [
      `form.otherType.actions.${actionKey}`,
      `form.otherType.${actionKey}`,
      `common.requestTypes.${actionKey}`,
      `common.otherActions.${actionKey}`
    ];

    let actionLabel = '';
    for (const k of candidateKeys) {
      const tVal = $t(k);
      if (tVal && tVal !== k) {
        actionLabel = tVal;
        break;
      }
    }

    if (!actionLabel) {
      actionLabel = actionKey.replace(/_/g, ' ');
      actionLabel = actionLabel.charAt(0).toUpperCase() + actionLabel.slice(1);
    }

    return (baseLabel || $t('common.requestTypes.other_type') || 'Otro tipo') + (actionLabel ? ' - ' + actionLabel : '');
  }

  return baseLabel || '-';
});

// Visible fields according to request type (this view does not render `company` or `liquidate`)
const visible = computed(() => {
  const type = requestData.value?.type;
  const v = {
    cups: true,
    name: false,
    email: false,
    dni: false,
    telephone: false,
    iban: false,
    supply_address: false,
    user_address: false,
    postal: false,
    municipality: false,
    // Lectura de contador: se pide solo en cambio de titularidad y de
    // comercializadora (SOL-05). En el resto de tipos el bloque aparece
    // únicamente si hay un valor heredado.
    meter_readings: false,
    file: true,
  };

  switch (type) {
    case 'supplies': // Alta de suministro
      v.name = v.dni = v.email = v.telephone = v.supply_address = v.user_address = v.postal = v.municipality = true;
      v.iban = true;
      break;
    case 'change_ownership': // Titular
      v.name = v.dni = v.email = v.telephone = v.supply_address = v.user_address = v.postal = v.municipality = true;
      v.iban = true;
      v.meter_readings = true;
      break;
    // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
    // case 'change_supplier': // Comercializadora (mismo titular)
    //   v.name = v.dni = v.email = v.telephone = v.supply_address = v.user_address = v.postal = v.municipality = true;
    //   v.iban = true;
    //   v.meter_readings = true;
    //   break;
    case 'account_change': // Cambio de cuenta
      v.cups = true;
      v.iban = true;
      v.supply_address = v.postal = v.municipality = true;
      v.telephone = true;
      v.name = v.email = v.dni = false;
      break;
    case 'invoice': // Factura
      v.cups = true;
      v.supply_address = v.postal = v.municipality = v.file = v.telephone = true;
      // La dirección de correspondencia se pide en factura, igual que en alta y cambio de titular
      v.user_address = true;
      v.name = v.email = v.dni = v.iban = false;
      break;
    case 'other_type': // Otro tipo
      v.cups = true;
      v.telephone = v.supply_address = v.postal = v.municipality = v.file = true;
      v.email = requestData.value?.other_action === 'cambio_direccion_postal' || !!requestData.value?.email;
      v.name = v.dni = v.iban = v.user_address = false;
      break;
    default:
      v.name = v.email = v.dni = v.telephone = v.supply_address = v.postal = v.municipality = true;
  }

  return v;
});

const canUploadFiles = computed(() => {
  return Boolean(requestData.value);
});

const getFileUploaderName = (file) => {
  return file.user || file.uploader?.username || file.uploader?.name || '-';
};

const formatFileUploadDate = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '-';

  return parsed.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

// El backend resuelve la propiedad de la solicitud y las coberturas
// expresamente autorizadas; el front se limita a respetar ese permiso.
const canEditRequest = computed(() => requestData.value?.can_edit === true);

const isAssignedToAnotherManager = computed(
  () => Boolean(requestData.value) && !canEditRequest.value
);

// El histórico interno solo lo ven los perfiles responsables autorizados.
const canViewHistory = computed(() => requestData.value?.can_view_history === true);

const isRequestLockedForWriting = computed(() => {
  const status = (requestData.value?.status || '').toString().toLowerCase();
  return ['cancel', 'results'].includes(status) || !canEditRequest.value;
});

// Los datos del titular son información interna: solo los perfiles de ADS los
// consultan y los mantienen desde esta vista.
const isAdsUser = checkIsAdsUser();

// Una vez creada la solicitud, la tipología solo la cambia ADS: el cliente no,
// porque Back Office ya puede estar gestionando la inicial (ADSREC-0004).
const canChangeType = computed(() => isAdsUser && canEditRequest.value);

const handleHolderDataSaved = (holder) => {
  if (!requestData.value) return;
  Object.assign(requestData.value, holder);
};

const handleOperationalDetailsSaved = (details) => {
  if (!requestData.value) return;
  requestData.value.registration_classification = details.registration_classification ?? '';
  requestData.value.pending_reason = details.pending_reason ?? '';
};

const closeTypeModal = () => {
  showTypeModal.value = false;
  typeErrorKeys.value = [];
};

const handleTypeUpdate = async (payload) => {
  if (!payload?.type || isUpdatingType.value) return;
  // Si mientras el modal estaba abierto la solicitud dejó de ser editable,
  // se explica en lugar de no hacer nada al pulsar «Guardar cambio».
  if (!canChangeType.value) {
    typeErrorKeys.value = [isAdsUser
      ? 'requestDetail.locked.assignedToAnotherManager'
      : 'requestTypeChange.errors.onlyAds'];
    return;
  }
  isUpdatingType.value = true;
  typeErrorKeys.value = [];

  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_URL}/request/update/${id}`,
      payload,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );

    if (response.data?.value) {
      await fetchRequestDetail();
      showTypeModal.value = false;
      toast.success($t('requestTypeChange.updated'));
    } else {
      typeErrorKeys.value = ['requestTypeChange.errors.generic'];
    }
  } catch (typeUpdateError) {
    console.error('Error updating request type:', typeUpdateError);
    typeErrorKeys.value = requestTypeErrorKeys(typeUpdateError);
  } finally {
    isUpdatingType.value = false;
  }
};

// Methods
// const handleClickCancelRequest = () => {
//   showConfirmModal.value = true;
// };

const handleCloseConfirmModal = () => {
  showConfirmModal.value = false;
};

const confirmCancelRequest = async () => {
  if (isUpdatingStatus.value) return;

  isUpdatingStatus.value = true;
  console.log('Cancelando solicitud...');

  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_URL}/request/update/${id}`,
      { status: 'cancel' },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (response.data?.value) {
      console.log('Respuesta de actualización:', response.data.value);
      requestData.value = response.data.value;
      lastUpdateTime.value = new Date().getTime();
      showConfirmModal.value = false;

      // Mostrar el toast con duración más corta
      toast.success("Solicitud cancelada con éxito", {
        autoClose: 500,
        position: "top-right",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      requestData.value = null;
      error.value = "No se encontraron datos para esta solicitud.";
      toast.error("Error al cancelar la solicitud");
    }
  } catch (err) {
    console.error("Error al cancelar la solicitud:", err);
    toast.error("Error al cancelar la solicitud");
  } finally {
    isUpdatingStatus.value = false;
  }
};

// const previousYear = () => {
//   currentYear.value--;
// };

// const nextYear = () => {
//   currentYear.value++;
// };

// const selectMonth = (monthIndex) => {
//   selectedMonth.value = monthIndex;
//   // Reset selected day when changing month
//   selectedDay.value = null;
// };

const fetchRequestDetail = async () => {
  if (!id) {
    error.value = "No ID provided in route.";
    loading.value = false;
    return;
  }

  // Si acabamos de actualizar, no hacemos el fetch
  if (lastUpdateTime.value && (new Date().getTime() - lastUpdateTime.value) < 5000) {
    return;
  }

  if (isFirstLoad.value) {
    loading.value = true;
  }
  error.value = null;
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/request/get/${id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    if (response.data?.value) {
      // Mostrar la estructura completa justo antes de asignar
      requestData.value = response.data.value;
      // Update files data from the request response
      if (response.data.value.files) {
        itemsFiles.value = response.data.value.files.map(file => ({
          id: file.id,
          date: formatFileUploadDate(file.created_at),
          documental_type: file.documental_type || '-',
          name: file.file_name,
          user: getFileUploaderName(file),
          file_path: file.file_path,
          file_name: file.file_name,
          is_available: file.is_available !== false,
          preview_url: `${import.meta.env.VITE_API_URL}/request/file/${file.id}/download?disposition=inline`,
          download_url: `${import.meta.env.VITE_API_URL}/request/file/${file.id}/download`
        }));
      }
    } else {
      requestData.value = null;
      if (isFirstLoad.value) {
        error.value = "No se encontraron datos para esta Comunidades.";
      }
    }
  } catch (err) {
    console.error("Error fetching Comunidades detail:", err);
    if (isFirstLoad.value) {
      error.value = "Failed to load Comunidades details.";
    }
    requestData.value = null;
  } finally {
    if (isFirstLoad.value) {
      loading.value = false;
    }
    isFirstLoad.value = false;
  }
};

const handlePageChangefiles = (newPage) => {
  currentPageFiles.value = newPage;
  // No need to fetch files data since it comes with the request
};

// const hasEventOnDay = (day) => {
//   if (!requestData.value?.events?.length) return false;
//   return requestData.value.events.some(event => {
//     const eventDate = new Date(event.created_at);
//     return eventDate.getDate() === day &&
//       eventDate.getMonth() === selectedMonth.value &&
//       eventDate.getFullYear() === currentYear.value;
//   });
// };

// const getEventForDay = (day) => {
//   if (!requestData.value?.events?.length) return null;
//   return requestData.value.events.find(event => {
//     const eventDate = new Date(event.created_at);
//     return eventDate.getDate() === day &&
//       eventDate.getMonth() === selectedMonth.value &&
//       eventDate.getFullYear() === currentYear.value;
//   });
// };

// const getEventsForDay = (day) => {
//   if (!requestData.value?.events?.length) return [];
//   return requestData.value.events.filter(event => {
//     const eventDate = new Date(event.created_at);
//     return eventDate.getDate() === day &&
//       eventDate.getMonth() === selectedMonth.value &&
//       eventDate.getFullYear() === currentYear.value;
//   });
// };

const parseValidDate = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatTimelineDate = (value) => {
  const parsed = parseValidDate(value);
  if (!parsed) return '-';
  return parsed.toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

const formatDuration = (milliseconds) => {
  if (!Number.isFinite(milliseconds) || milliseconds <= 0) return '0 min';

  const minutes = Math.floor(milliseconds / (1000 * 60));
  if (minutes < 60) return `${Math.max(1, minutes)} min`;

  const hours = milliseconds / (1000 * 60 * 60);
  if (hours < 24) return `${hours.toFixed(hours >= 10 ? 0 : 1)} h`;

  const days = milliseconds / (1000 * 60 * 60 * 24);
  return `${days.toFixed(days >= 10 ? 0 : 1)} días`;
};

const formatScaleTickLabel = (offsetMilliseconds, mode, startDate) => {
  const hours = Math.round(offsetMilliseconds / (1000 * 60 * 60));
  const days = Math.round(offsetMilliseconds / (1000 * 60 * 60 * 24));

  const tickDate = startDate
    ? new Date(startDate.getTime() + offsetMilliseconds)
    : null;

  const timeLabel = tickDate
    ? tickDate.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
    : '-';

  if (mode === 'ten-minutes') {
    return timeLabel;
  }

  if (mode === 'days') {
    return `D+${days}`;
  }

  return timeLabel !== '-' ? timeLabel : `${hours} h`;
};

const statusTimeline = computed(() => {
  if (!requestData.value) {
    return {
      events: [],
      startLabel: '-',
      endLabel: '-',
      totalDurationLabel: '-'
    };
  }

  const baseCreatedAt = parseValidDate(requestData.value.created_at);
  const rawEvents = deduplicateTimelineEvents(
    Array.isArray(requestData.value.events) ? requestData.value.events : []
  );

  const normalizedEvents = rawEvents
    .map((event) => {
      const eventDate = parseValidDate(event.created_at);
      if (!eventDate) return null;
      return {
        id: event.id,
        title: event.title || 'status',
        created_at: event.created_at,
        date: eventDate
      };
    })
    .filter(Boolean)
    .sort((firstEvent, secondEvent) => firstEvent.date.getTime() - secondEvent.date.getTime());

  if (baseCreatedAt) {
    const hasCreatedEvent = normalizedEvents.some((event) => event.title === 'created');
    if (!hasCreatedEvent) {
      normalizedEvents.unshift({
        id: 'request-created',
        title: 'created',
        created_at: requestData.value.created_at,
        date: baseCreatedAt
      });
    }
  }

  // Se muestran TODOS los estados en su fecha real, incluido el cierre ('results'/'cancel').
  const visibleEvents = normalizedEvents;

  if (!visibleEvents.length) {
    return {
      events: [],
      startLabel: '-',
      endLabel: '-',
      totalDurationLabel: '-'
    };
  }
  const startDate = baseCreatedAt || visibleEvents[0].date;
  const endDate = visibleEvents[visibleEvents.length - 1].date;
  const totalMilliseconds = Math.max(0, endDate.getTime() - startDate.getTime());

  const minuteMs = 1000 * 60;
  const hourMs = minuteMs * 60;
  const dayMs = hourMs * 24;

  let scaleMode = 'hours';
  let scaleStepMs = hourMs;

  if (totalMilliseconds > 0 && totalMilliseconds < hourMs) {
    scaleMode = 'ten-minutes';
    scaleStepMs = 10 * minuteMs;
  } else if (totalMilliseconds >= dayMs) {
    scaleMode = 'days';
    scaleStepMs = dayMs;
  }

  const scaleTicks = [];
  if (totalMilliseconds === 0) {
    scaleTicks.push({
      id: 0,
      position: 0,
      label: formatScaleTickLabel(0, scaleMode, startDate)
    });
  } else {
    const startMs = startDate.getTime();
    const endMs = endDate.getTime();

    if (scaleMode === 'ten-minutes') {
      const firstRoundedTickMs = Math.ceil(startMs / scaleStepMs) * scaleStepMs;

      for (let tickMs = firstRoundedTickMs; tickMs <= endMs; tickMs += scaleStepMs) {
        const offset = tickMs - startMs;
        const position = (offset / totalMilliseconds) * 100;
        scaleTicks.push({
          id: offset,
          position: Math.min(100, Math.max(0, position)),
          label: formatScaleTickLabel(offset, scaleMode, startDate)
        });
      }
    } else if (scaleMode === 'hours') {
      const firstRoundedTickMs = Math.ceil(startMs / scaleStepMs) * scaleStepMs;

      for (let tickMs = firstRoundedTickMs; tickMs <= endMs; tickMs += scaleStepMs) {
        const offset = tickMs - startMs;
        const position = (offset / totalMilliseconds) * 100;
        scaleTicks.push({
          id: offset,
          position: Math.min(100, Math.max(0, position)),
          label: formatScaleTickLabel(offset, scaleMode, startDate)
        });
      }
    } else {
      for (let offset = 0; offset <= totalMilliseconds; offset += scaleStepMs) {
        const position = (offset / totalMilliseconds) * 100;
        scaleTicks.push({
          id: offset,
          position: Math.min(100, Math.max(0, position)),
          label: formatScaleTickLabel(offset, scaleMode, startDate)
        });
      }

      const hasEndTick = scaleTicks.some(tick => tick.id === totalMilliseconds);
      if (!hasEndTick) {
        scaleTicks.push({
          id: totalMilliseconds,
          position: 100,
          label: formatScaleTickLabel(totalMilliseconds, scaleMode, startDate)
        });
      }
    }
  }

  const events = visibleEvents.map((event, index) => {
    const elapsed = Math.max(0, event.date.getTime() - startDate.getTime());
    const position = totalMilliseconds > 0 ? (elapsed / totalMilliseconds) * 100 : 0;
    const displayKey = event.title;
    return {
      id: event.id,
      titleLabel: $t(`common.requestStatus.${displayKey}`) || displayKey,
      dateLabel: formatTimelineDate(event.created_at),
      elapsedLabel: totalMilliseconds > 0 ? formatDuration(elapsed) : '0 min',
      position: Math.min(100, Math.max(0, position)),
      isLast: index === visibleEvents.length - 1
    };
  });

  return {
    events,
    scaleTicks,
    startLabel: formatTimelineDate(startDate),
    endLabel: formatTimelineDate(endDate),
    totalDurationLabel: formatDuration(totalMilliseconds)
  };
});

const openDocumentUploadModal = () => {
  if (!canUploadFiles.value || isRequestLockedForWriting.value) return;
  showDocumentUploadModal.value = true;
};

const handleDocumentUploadSuccess = async () => {
  await fetchRequestDetail();
};

const startPolling = () => {
  // Clear any existing interval
  if (pollingInterval.value) {
    clearInterval(pollingInterval.value);
  }

  // Set up new interval to fetch data every 15 seconds
  pollingInterval.value = setInterval(() => {
    fetchRequestDetail();
  }, 15000);
};

const stopPolling = () => {
  if (pollingInterval.value) {
    clearInterval(pollingInterval.value);
    pollingInterval.value = null;
  }
};


const navigateToRequest = (requestId) => {
  if (requestId) {
    const href = router.resolve({ name: 'request-detail', params: { id: String(requestId) } }).href;
    window.open(href, '_blank', 'noopener,noreferrer');
  }
};

onMounted(() => {
  fetchRequestDetail();
  startPolling();
  // Buscar solicitudes relacionadas al cargar los datos principales
  // Se ejecuta tras la primera carga de datos
  const unwatch = watch(requestData, (val) => {
    fetchRelatedRequests(val?.cups_light);
    fetchRelatedGasRequests(val?.cups_gas);
  }, { immediate: true });
  onUnmounted(() => unwatch());
});

// Clean up interval when component is unmounted
onUnmounted(() => {
  stopPolling();
});
</script>
